import { Type } from '@angular/core';
import { Observable } from 'rxjs';

export class WucVideoClass {
    constructor(public noVideoComponent: Type<any>, public isVideoVisible$: Observable<boolean>) {}
}
